var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBgEllipse2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 290,
  height: 153,
  fill: "none",
  viewBox: "0 0 290 153"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#bg-ellipse-2_svg__a)",
  filter: "url(#bg-ellipse-2_svg__b)",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#bg-ellipse-2_svg__c)",
  fillOpacity: 0.6,
  d: "M50.795 79.674c-7.165-14.272 35.086-28.081 87.084-29.547s94.055 9.966 101.22 24.238-29.18 27.031-81.178 28.497c-51.999 1.466-99.96-8.915-107.126-23.188"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bg-ellipse-2_svg__c",
  x1: 157.921,
  x2: 156.444,
  y1: 102.862,
  y2: 50.488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9DD9D4",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9DD9D4"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "bg-ellipse-2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h290v153H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "bg-ellipse-2_svg__b",
  width: 290,
  height: 153,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur_2348_25570",
  stdDeviation: 25
})))));
export default SvgBgEllipse2;